import React, { useState } from 'react';
import AdminCorneliusTasks from '../pages/AdminCorneliusTasks';
import AdminCorneliusMemories from '../pages/AdminCorneliusMemories';
import AdminCorneliusEntities from '../pages/AdminCorneliusEntities';
import AdminCorneliusConsolidations from '../pages/AdminCorneliusConsolidations';
import AdminCorneliusSkills from '../pages/AdminCorneliusSkills';
import AdminCorneliusApprovals from '../pages/AdminCorneliusApprovals';
import AdminCorneliusUsage from '../pages/AdminCorneliusUsage';
import AdminCorneliusRetention from '../pages/AdminCorneliusRetention';
import AdminCorneliusEval from '../pages/AdminCorneliusEval';
import AdminCorneliusGraph from '../pages/AdminCorneliusGraph';

const SUB_TABS = [
  { id: 'tasks',          label: 'Tasks' },
  { id: 'approvals',      label: 'Approvals' },
  { id: 'memory',         label: 'Memory' },
  { id: 'entities',       label: 'Entities' },
  { id: 'consolidations', label: 'Consolidations' },
  { id: 'skills',         label: 'Skills' },
  { id: 'eval',           label: 'Eval' },
  { id: 'graph',          label: 'Graph' },
  { id: 'usage',          label: 'Usage' },
  { id: 'retention',      label: 'Retention' },
];

/**
 * Nested section under OPO: primary tab "Cornelius" →
 *   Tasks | Memory | Entities | Consolidations | Skills
 *
 * Each sub-tab is its own page component so they can be deep-linked from
 * outside as well (see App.js routes /admin/cornelius-{tasks,memories}).
 */
const OPOCorneliusTab = () => {
  const [activeSubTab, setActiveSubTab] = useState('tasks');

  return (
    <div className="opo-cornelius-panel">
      <div className="opo-cornelius-subtabs">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`opo-sub-tab-button ${activeSubTab === tab.id ? 'opo-sub-tab-active' : ''}`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="opo-cornelius-subcontent">
        {activeSubTab === 'tasks'          && <AdminCorneliusTasks />}
        {activeSubTab === 'approvals'      && <AdminCorneliusApprovals />}
        {activeSubTab === 'memory'         && <AdminCorneliusMemories />}
        {activeSubTab === 'entities'       && <AdminCorneliusEntities />}
        {activeSubTab === 'consolidations' && <AdminCorneliusConsolidations />}
        {activeSubTab === 'skills'         && <AdminCorneliusSkills />}
        {activeSubTab === 'eval'           && <AdminCorneliusEval />}
        {activeSubTab === 'graph'          && <AdminCorneliusGraph />}
        {activeSubTab === 'usage'          && <AdminCorneliusUsage />}
        {activeSubTab === 'retention'      && <AdminCorneliusRetention />}
      </div>
    </div>
  );
};

export default OPOCorneliusTab;
